import { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import { getCurrentPullRequestUrlPieces } from 'src/redux/pull-request/selectors';
import urls from 'src/redux/pull-request/urls';
import authRequest from 'src/utils/fetch';

type UseFetchPendingReviewersOuput = {
  users: BB.User[] | null;
  loading: boolean;
  error: boolean;
};

// hook to fetch list of pending reviewers for a pull request
// (part of the multi-comment-review project)
export const useFetchPendingReviewers = (): UseFetchPendingReviewersOuput => {
  const { owner, slug, id } = useSelector(getCurrentPullRequestUrlPieces);
  const url = urls.api.internal.pendingReviews(owner, slug, id!);

  const [users, setUsers] = useState<BB.User[] | null>(null);

  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<boolean>(false);

  useEffect(() => {
    let mounted = true;

    const getData = async () => {
      try {
        const res = await fetch(authRequest(url));

        if (!res.ok) {
          throw new Error();
        }

        if (mounted) {
          const json = await res.json();
          setUsers(json);
          setLoading(false);
          setError(false);
        }
      } catch (e) {
        if (mounted) {
          setError(true);
          setLoading(false);
        }
      }
    };

    getData();

    return () => {
      mounted = false;
    };
  }, [url]);

  return { users, loading, error };
};
